import React from 'react'
import { Box, makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import isMobile from './utils/is-mobile'
import HNK from './images/hnk-theatre.jpeg'

const useStyles = isMobile()
  ? makeStyles({
      topBar: {
        fontSize: 30,
        textAlign: 'center',
        paddingTop: 5,
        paddingBottom: 5
      },
      mainTitle: {
        fontSize: 40
      },
      descriptionParagraph: {
        marginTop: 10,
        width: '90%',
        alignSelf: 'center',
        display: 'inline-block',
        fontSize: 15
      }
    })
  : makeStyles({
      topBar: {
        fontSize: 30,
        textAlign: 'center',
        paddingTop: 20,
        paddingBottom: 20
      },
      mainTitle: {
        fontSize: 40
      },
      descriptionParagraph: {
        marginTop: 20,
        width: '60%',
        alignSelf: 'center',
        display: 'inline-block',
        fontSize: 15,
        whiteSpace: 'pre-line',
        flexDirection: 'row'
      }
    })

const About: React.FC = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <Box className={classes.topBar}>
      <Box className={classes.mainTitle}>{t('about')}</Box>
      <Box className={classes.descriptionParagraph}>{t('aboutOne')}</Box>
      <Box className={classes.descriptionParagraph}>{t('aboutTwo')}</Box>
      <Box className={classes.descriptionParagraph}>{t('aboutThree')}</Box>
      <Box className={classes.descriptionParagraph}>
        <Box>
          <img src={HNK} alt='a' width='35%' />
        </Box>
        <Box>HNK Varaždin, Croatia</Box>
        <Box pt={2}>Translated by: Nataša Tomanović</Box>
        <Box>Prijevod: Nataša Tomanović</Box>
      </Box>
    </Box>
  )
}

export default About
